export const featuredAssistantIds = [
  'c311b6fa-96b1-47ee-9b3b-e15e2c59674d', // Backstage
  'e5ca8a9a-1739-4b93-8e6c-62932026cd21', // Elle
];
export const backstageAssistantId = featuredAssistantIds[0];
export const ragAssistantId = 'rag-assistant-backstage';
export const defaultAssistantId = ragAssistantId;

export const defaultSystemPrompt =
  'You are a helpful assistant for internal documentation and development support at Bayer. Always provide clear, actionable answers.';

export const mgaUrl = 'https://chat.int.bayer.com';
